import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { Heading6 } from '~/theme/utils/typography'
import { UniversalContainer } from '~/utils/grid'

import IconView from '~/shared/atoms/Icon'

export const Container = styled.div`
  position: relative;
  box-shadow: ${({ theme }) => theme.commons.shadow.xxs};
  z-index: 2;
`

export const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.colors.bgColor};
  position: relative;
  height: 60px;
  min-height: 60px;
  padding: 18px 0;

  ${mediaQueryUp('m')} {
    height: 88px;
    min-height: 88px;
    padding: 32px 0;
  }
`

export const Content = styled(UniversalContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`

export const Subheader = styled.div``

export const Logo = styled.img<{ size?: 'regular' | 'big' }>`
  position: absolute;
  left: 50%;
  //top: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: ${({ size }) => (size === 'big' ? '32px' : '24px')};

  ${mediaQueryUp('m')} {
    height: ${({ size }) => (size === 'big' ? '48px' : '32px')};
  }
`

export const BackButton = styled.button`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray[1000]};
`

export const BackButtonIcon = styled(IconView)`
  width: 24px;
  height: 24px;
  filter: ${({ theme }) => theme.filters.blue[200]};
`

export const BackButtonText = styled(Heading6)`
  display: none;

  ${mediaQueryUp('m')} {
    display: block;
  }
`
